import React from "react"
import { Card, Grid } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { ReactComponent as DebtPayoffIcon } from "uikit/Icons/debtpayoff-goal.svg"
import { formatCurrency } from "uikit/utilities"

const DebtPayoff = ({
  id,
  account_ids,
  monthly_amount,
  baseUrl,
  type,
  accounts
}) => {
  const payoffAmount = -account_ids.reduce(
    (total, id) => total + ((accounts[id] && accounts[id].balance) || 0),
    0
  )
  return (
    <Card>
      <Card.Content>
        <Link
          to={`${baseUrl}/goals/${id}/${type.toLowerCase()}`}
          className="navlink"
        >
          <Grid>
            <Grid.Row columns="equal">
              <Grid.Column verticalAlign="middle" width={4}>
                <DebtPayoffIcon />
              </Grid.Column>
              <Grid.Column>
                <Grid>
                  <Grid.Row columns={1}>
                    <Grid.Column>
                      <span className="GenericCard__LinkTitle">
                        Debt Payoff
                      </span>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2} style={{ paddingTop: "0px" }}>
                    <Grid.Column verticalAlign="bottom">
                      <p
                        className="GoalCard_SecondText"
                        style={{
                          fontSize: "2.4em",
                          marginBottom: "0",
                          color: "#8ed72a"
                        }}
                      >
                        {formatCurrency(payoffAmount)}
                      </p>
                      <p className="greyed-text">total to payoff</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Link>
      </Card.Content>
    </Card>
  )
}

export default DebtPayoff
